module.exports = __webpack_public_path__ + "img/jiya.4419082d.jpg";